import sensors from "sa-sdk-javascript";
import store from "../store";
import { getStore, tokenKey } from "/utils/storage";

const debug = process.env.DEBUG === "true";

// $WebPageLeave
sensors.use("PageLeave", {
  heartbeat_interval_time: 5,
  max_duration: 5 * 24 * 60 * 60,
  isCollectUrl: function () {
    return true;
  },
});

sensors.init({
  name: "sensors",
  server_url: process.env.SENSORS_DOMAIN,
  show_log: debug,
  cross_subdomain: false,
  is_track_single_page: true,
  use_client_time: true,
  send_type: "beacon",
  heatmap: {
    // $WebClick
    clickmap: "default",
    // $WebStay
    scroll_notice_map: "default",
  },
});

const commonSensor = store.state.commonSensor;
sensors.registerPage({
  platform_type: function () {
    // if (debug) {
    //   console.log('platform_type', commonSensor.platform_type)
    // }
    return commonSensor.platform_type;
  },
  vip_level: function () {
    // if (debug) {
    //   console.log('vip_level', commonSensor.vip_level)
    // }
    return commonSensor.vip_level;
  },
  country_station: function () {
    // if (debug) {
    //   console.log('country_station', commonSensor.country_station)
    // }
    return commonSensor.country_station;
  },
  is_login: function () {
    return !!getStore(tokenKey);
  },
});

// $pageview
sensors.quick("autoTrack");

window.sensors = sensors;

export default sensors;



// WEBPACK FOOTER //
// ./src/utils/sensor.js